/**
 * API prefix for accounting software API endpoints
 */
export const API_PREFIX = 'v1';
